import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Stethoscope } from 'lucide-react';
import { Button } from '../ui/button';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', href: '/' },
    { name: 'Blog', href: '/blog' },
    { name: 'Contact', href: '/contact' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 sm:gap-3">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-500 rounded-lg sm:rounded-xl flex items-center justify-center">
              <Stethoscope className="w-5 h-5 sm:w-7 sm:h-7 text-white" />
            </div>
            <span className="text-xl sm:text-2xl font-bold">
              <span className="text-gray-900">Doktor</span>{' '}
              <span className="text-teal-500">Gigi</span>
            </span>
          </Link>

          {/* Desktop CTA Buttons */}
          <div className="hidden lg:flex items-center gap-4">
            <Link to="/book-consultation">
              <Button className="bg-teal-500 hover:bg-teal-600 text-white rounded-full px-6 py-2.5 font-medium">
                Book Free Appointment
              </Button>
            </Link>
            <Link to="/contact">
              <Button variant="outline" className="border-2 border-gray-200 text-gray-700 hover:border-teal-500 hover:text-teal-500 rounded-full px-6 py-2.5 font-medium">
                Contact Us
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X className="w-5 h-5 sm:w-6 sm:h-6" /> : <Menu className="w-5 h-5 sm:w-6 sm:h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="lg:hidden py-4 border-t border-gray-100">
            <div className="flex flex-col gap-3 sm:gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className={`text-sm sm:text-base font-medium py-2 transition-colors ${
                    location.pathname === link.href ? 'text-teal-500' : 'text-gray-600'
                  }`}
                  onClick={() => setIsOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
              <div className="flex flex-col gap-2 sm:gap-3 pt-3 sm:pt-4">
                <Link to="/book-consultation" onClick={() => setIsOpen(false)}>
                  <Button className="w-full bg-teal-500 hover:bg-teal-600 text-white rounded-full py-2 sm:py-2.5 font-medium text-sm sm:text-base">
                    Book Free Appointment
                  </Button>
                </Link>
                <Link to="/contact" onClick={() => setIsOpen(false)}>
                  <Button variant="outline" className="w-full border-2 border-gray-200 text-gray-700 rounded-full py-2 sm:py-2.5 font-medium text-sm sm:text-base">
                    Contact Us
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
